<template>
  <footer class="footWrapper noprint">
    <nav class="topNav">
    	<div @click="navClick('home')">网站首页</div>
    	<div @click="navClick('logvipServices')">会员服务</div>
    	<div @click="navClick('aboutUs')">关于我们</div>
    	<div @click="navClick('telphone')">联系方式</div>
    	<!-- <div @click="navClick('registGuide')">注册指南</div> -->
    	<div @click="navClick('legalStatement')">法律声明</div>
    	<!-- <div @click="navClick('adverService')">广告服务</div> -->
    </nav>
    <div class="middleText">
	    <span>广告资讯热线：0571-86721123</span>
	    <span>微信公众号：T81390212</span>
	    <!-- <span>邮箱地址：tp.service@hztls.cn</span> -->
	    <br>
	    <span class="spanHover" @click="toBeian">网站备案/许可证号：浙ICP备13013007号-1</span>
	    <span>公安部备案号：33010502000187</span>
	    <span>邮编：310000</span>
	    <br>
	    <span>Copyright © 2012-2023 CNFZFLW.com. All Rights Reserved</span>
	    <span>微博：</span>
	    <a href="http://e.weibo.com/cnfzflw/" target="_blank">
	    	<img 
	    		src="https://www.cnfzflw.com/static/theme/img/weibo.png" 
	    		alt="官方微博"
	    		style="width: 60px; height: 20px; position: absolute; margin-top: 4px; margin-left: -20px;">
	    </a>
	    <br>
	    <span>由杭州天露石互联网科技有限公司提供技术支持</span>
    </div>
    <div class="bottomImg">
    	<img src="@/assets/images/footer.png" height="60" width="560" alt="img">
    </div>
  </footer>
</template>

<script>
  import { getToken } from '@/utils/auth' // 验权
	export default {
	  name: 'pageFoot',
	  data() {
	  	return {
	  		userData: {},				// 登录信息
	  	}
	  },
	  methods: {
      // 是否已经登录
      isLogin(name) {
        // 如果没有登陆或者登录失效跳转到登录页面
        if (getToken()) {
          this.userData = JSON.parse(getToken())
          return true
        } else {
          this.$message({message: '未登录或登录失效，请登录！',type: 'error',duration:2000})
          this.$route.params.name = 'logvipServices'
          setTimeout(() => {
            this.$router.push({name: 'login', params: this.$route.params})
          }, 2000)
          return false
        }
      },
	  	navClick(pathname) {
	      if (pathname === 'logvipServices') {
	      	let isok = this.isLogin()
	      	if (isok) {
	      		if (this.userData.vip_type == 0 || this.userData.is_company == 1) {
		  				const url = this.$router.resolve({ name: 'logvipSelect' })
	  					window.open(url.href, "_blank")
		  			} else if (this.userData.vip_type > 0) {
		  				const url = this.$router.resolve({ name: 'logvipServices' })
		  				window.open(url.href, "_blank")
		  			}
	      	}
	      } else {
	        // 新页面打开网页
	        const url = this.$router.resolve({ name: pathname });
	        window.open(url.href, "_blank");
	      }
	  	},
      // 跳转到备案页面 http://www.beian.miit.gov.cn/
      toBeian() {
        window.open("https://beian.miit.gov.cn", "_blank")
      },
	  }
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@import '@/styles/index.scss';
	.footWrapper {
		width: 100%;
		height: 25px;
		line-height: 25px;
		margin: 30px 0;
		text-align: center;
		background-color: $fontColor;
		.topNav {
			div {
				height: 20px;
				line-height: 20px;
				padding: 0 5px;
				display: inline-block;
				font-size: 14px;
				border-right: 1px solid #fff;
				color: #fff;
			}
			div:last-child {
				border-right: 0;
			}
			div:hover {
				cursor: pointer;
				color: #000;
			}
		}
		.middleText {
			margin-top: 20px;
			position: relative;
			span {
				margin: 20px;
				font-size: 12px;
			}
			.spanHover:hover {
				cursor: pointer;
			}
		}
		.bottomImg {
			margin: 10px;
		}
	}
  @media print {
    .noprint {
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/pageFoot.vue